import React from 'react'
import useSWR from 'swr'
import axios from 'axios';
import { useCookies } from "react-cookie";
import Cookies from 'universal-cookie';
import Login from '../pages/Login';
import {useNavigate, useLocation } from "react-router-dom";
const UserApi = () => {
    let navigate = useNavigate();
    console.log("s")
    var geted = undefined;
    const cookiess = new Cookies();
    const [cookies, setCookie] = useCookies(["wtkn", "csrf", "client"]);
    if(cookiess.get("wtkn") === undefined) {
        var loginlink = window.location.href;
    var loginlink2 = loginlink.split("&");

        var geted = clearwtkn;
        if(loginlink2[1]===undefined){
        window.location.replace(`https://login.metincevener.com/login?redirect=react&${window.location.href}`);
        console.log("current url: " + loginlink2[1]);
        var geted = clearwtkn;
        console.log(2);
        }else{
            var clearwtknques = loginlink2[0].split("?")
            var clearwtkn = clearwtknques[1].replace("wtkn=", "");
            var clearclient = loginlink2[1].replace("client=", "");
            var clearscrf = loginlink2[2].replace("csrf=", "");
                console.log(clearwtkn)
        }
    }else{
        var geted = cookiess.get("wtkn"); 
        var clearwtkn = cookiess.get("wtkn");
        var clearclient = cookiess.get("client");
        var clearscrf = cookiess.get("csrf");
    }
    const fetcher = url => axios.post(url, null,  { params: {
        "wtkn" : cookies.wtkn,
        "csrf" : cookies.csrf,
        "client" : cookies.client,

      }}).then(res => res.data)
    const { data, error } = useSWR(`https://login.metincevener.com/login.php?wtkn=${geted}`, fetcher)
    //cookiess.set('wtkn', 'nad6hqygFs', { path: '/' });

    if (error) return <div>failed to load</div>
    if (!data) return <div>loading...</div>
    if(data){
        
    }
    
    return (
        {
        avatar: data.avatar,
        name : data.name,
        username : data.username,
        banner : data.banner,
        theme: data.theme,
        miniBanner: data.miniBanner,
        bio : data.bio,
        bioMd: data.bioMd,
        status: data.status,
        coin: data.coin,
        verify: data.verify,
        language: data.language,
        privStatus: data.privStatus,
        createDate: data.createDate,
        main:data.mail,
        whq:data.whq,
        csrf:clearscrf,
        token:clearclient,
        premiumStatus:data.premiumStatus,
        premiumDuration:data.premiumDuration
        }
    )
}

export default UserApi
